import {
  GET_REIMBURSMENT_DATA,
  HANDLE_REIMBURSMENT_PAGINATION,
  HANDLE_REIMBURSMENT_EXPENSE_CATAGORIES,
} from './action'

const initialState = {
  reimbursmentExpenses: [],
  reimbursementExpenseCategories: [],
  totalCount: 0,
  pagination: {
    skip: 0,
    limit: 10,
  },
}

const reimbursmentExpensesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REIMBURSMENT_DATA:
      return {
        ...state,
        reimbursmentExpenses: action.payload.reimbursmentExpenses,
      }
    case HANDLE_REIMBURSMENT_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case HANDLE_REIMBURSMENT_EXPENSE_CATAGORIES:
      return {
        ...state,
        reimbursementExpenseCategories: action.payload,
      }
    default:
      return state
  }
}

export default reimbursmentExpensesReducer
